module.exports = __webpack_public_path__ + "static/assets/f933130e73024cbe9bb321d507cd4b92.png";